import axios from 'axios';

let BASE_URL = 'https://admin.tongban.hongen.com/api';
if (process.env.NODE_ENV === 'development') {
  BASE_URL = 'http://device.test.hongen.com/api';
}
const SUBJECT_LIST_URL = `${BASE_URL}/anonymous/noscreenpad/subjects`;
const RESOURCE_LIST_URL = `${BASE_URL}/anonymous/noscreenpad/resources`;
const FIRMWARE_LIST_URL = `${BASE_URL}/anonymous/noscreenpad/versions`;

function getSubjectList() {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: SUBJECT_LIST_URL,
      data: {},
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getResourceList(subjectName, resourceName, pageNumber) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: RESOURCE_LIST_URL,
      params: {
        subject_name: subjectName,
        query_name: resourceName,
        page_num: pageNumber,
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getFirmwareList() {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: FIRMWARE_LIST_URL,
      data: {},
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  getSubjectList,
  getResourceList,
  getFirmwareList,
};
